import { useRef } from 'react';

export default function useDebouncedFunction(
  func: (...args: any) => any,
  delay: number
) {
  const ref: any = useRef();

  return (...args: any) => {
    clearTimeout(ref.current);
    ref.current = setTimeout(() => func(...args), delay);
  };
}
